import { Link } from "react-router-dom";
import { Instagram, Mail, ArrowUpRight } from "lucide-react";
import { SunriseCircle } from "./icons/SunriseCircle";
import { BRAND } from "../data/content";

export const Footer = () => (
  <footer className="relative bg-brand-forest text-brand-cream overflow-hidden grain" data-testid="footer">
    <div className="max-w-7xl mx-auto px-6 md:px-10 pt-24 pb-28 md:pb-12 relative z-10">
      <div className="grid md:grid-cols-2 gap-16 items-start">
        <div>
          <div className="flex items-center gap-3 mb-6">
            <SunriseCircle className="text-brand-goldBright" size={30} strokeWidth={1.4} />
            <span className="font-serif text-3xl">Brighter Tomorrows</span>
          </div>
          <p className="overline text-brand-goldBright mb-6">{BRAND.tagline}</p>
          <p className="font-serif italic text-xl md:text-2xl text-brand-cream/85 mb-8 max-w-sm leading-snug">
            Architecting lives that truly reflect who you are.
          </p>
          <Link
            to="/contact"
            data-testid="footer-cta"
            className="inline-flex items-center gap-2 font-serif italic text-4xl md:text-5xl text-brand-cream hover:text-brand-goldBright transition-colors duration-500"
          >
            Let's begin together <ArrowUpRight size={40} strokeWidth={1} />
          </Link>
        </div>

        <div className="md:justify-self-end space-y-6">
          <a
            href={`mailto:${BRAND.email}`}
            data-testid="footer-email"
            className="flex items-center gap-3 text-brand-cream/80 hover:text-brand-goldBright transition-colors duration-300"
          >
            <Mail size={18} /> <span className="text-sm tracking-wide lowercase">{BRAND.email.toLowerCase()}</span>
          </a>
          <a
            href={BRAND.instagramUrl}
            target="_blank"
            rel="noreferrer"
            data-testid="footer-instagram"
            className="flex items-center gap-3 text-brand-cream/80 hover:text-brand-goldBright transition-colors duration-300"
          >
            <Instagram size={18} /> <span className="text-sm tracking-wide">{BRAND.instagram}</span>
          </a>
          <div className="pt-6 flex flex-col gap-2 text-sm text-brand-cream/60">
            <Link to="/about" className="hover:text-brand-cream transition-colors">Meet Noelle</Link>
            <Link to="/method" className="hover:text-brand-cream transition-colors">The Method</Link>
            <Link to="/packages" className="hover:text-brand-cream transition-colors">Investment</Link>
          </div>
        </div>
      </div>

      <div className="mt-20 pt-8 border-t border-brand-forestSoft flex flex-col md:flex-row justify-between gap-4 text-xs text-brand-cream/50 tracking-wide">
        <span>© {new Date().getFullYear()} {BRAND.full} · Holistic Coaching</span>
        <span>Guided by {BRAND.architect}</span>
      </div>
    </div>
  </footer>
);
